export const types = {
  init: 'account/init',
  profile: 'account/profile',
};

export default {
  namespaced: true,
  state: {
    account: {},
    startingContentShown: '',
    profileForm: {},
    csrf: {},
  },
  mutations: {
    init(state, account) {
      state.account = account.account;
      state.startingContentShown = account.startingContentShown;
      state.profileForm = account.profileForm;
      state.csrf = account.csrf;
    },
    profile(state, { profile, profileForm }) {
      state.account.profile = { ...profile };
      state.profileForm = { ...profileForm };
    },
  },
};
